import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionListenerComponent } from './components/session-listener/session-listener.component';
import { RoleCheckComponent } from './components/role-check/role-check.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {HttpClient } from '@angular/common/http';

import { registerLocaleData } from '@angular/common';
import localeCo from '@angular/common/locales/es-CO';


export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

registerLocaleData(localeCo);

@NgModule({
  declarations: [SessionListenerComponent, RoleCheckComponent],
  imports: [CommonModule, TranslateModule],
})
export class InovaCoreSessionModule {}
